// extracted by mini-css-extract-plugin
export default {"skip":"styles_skip__qubtD","text":"styles_text__fDlsF"};